import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getMessaging, isSupported, Messaging } from 'firebase/messaging'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FCM_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

export const db        = getFirestore(app)
export const auth      = getAuth(app)
export const storage   = getStorage(app)
export const functions = getFunctions(app, 'us-central1')

export const getMessagingInstance = async (): Promise<Messaging | null> => {
  const supported = await isSupported().catch(() => false)
  return supported ? getMessaging(app) : null
}

// Resolves once Firebase Auth has restored (or confirmed no) session.
// Firestore calls must wait for this or rules will see request.auth as null.
export const authReady: Promise<void> = new Promise((resolve) => {
  const unsub = onAuthStateChanged(auth, () => { unsub(); resolve() })
})
